import { render, staticRenderFns } from "./SubCommentItem.vue?vue&type=template&id=63ae6320&"
import script from "./SubCommentItem.vue?vue&type=script&lang=js&"
export * from "./SubCommentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports